module.exports = function prettifyDay(day) {
  const splitNum = day.toString().split('');
  const firstNum = splitNum[0];
  const secondNum = splitNum[1];
  let newNum = '';

  if (firstNum === '0') {
    newNum = secondNum;
  } else {
    newNum = day;
  }
  return newNum;
};



// WEBPACK FOOTER //
// ./src/helpers/prettifyDay.js